module.exports = __webpack_public_path__ + "static/media/laura_lu.e03284cd.png";